import React, { Component, useEffect } from 'react';
import {
  Select,
  MenuItem,
  ListItemText,
  InputLabel,
  Box,
  FormControl,
  OutlinedInput,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Icon,
  LinearProgress,
  linearProgressClasses,
  CardActions,
  Button,
  Chip,
  CircularProgress
} from '@mui/material';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash';
import FormLabel from '@mui/material/FormLabel';
import { _freedomAxios, _axios } from 'src/plugins/axios';
import { Notify } from 'src/components/common/Notify';

class EntityCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      corporateName: '',
      corporateAddress: '',
      pincode: '',
      hrEmail: '',
      hrMobileNumber: '',
      hrName: '',
      entityType: '',
      entityTypeName: '',
      newEntityId: 0,
      entityList: [],
      entityRelationList: [],
      entityId: null,
      entityRelationId: 0,
      RelationType: '',
      RelationTypename: '',
      corporateType: 'Non-TPA',
      createdBy: 20000,
      modifiedBy: 20000,
      stepper: 1,
      LoginTypeList: [
        { id: 'EMAIL', value: 'EMAIL' },
        { id: 'Employeeid@domain', value: 'EMPID' }
      ],
      loginType: '',
      emailDomain: '',
      emailDomainAlias: '',
      entityIdInfo: [],
      isSSO: 0,
      SSOurl: '',
      selfOnbaordingEnabled: 0,
      stateId: '',
      stateName: '',
      stateIdList: [],
      mediMarketId: 0,
      newEntityRealtion: 0,
      IWPID: 0
    };
  }

  mediMarketTableMapping(payLoad) {
    _freedomAxios
      .post('corporate/createMediMarket', payLoad)
      .then((response) => {
        if (response.data.isSuccess) {
          let res = response.data.result;
          this.setState({ mediMarketId: res[0].ID });
        } else {
          let string = `mediMarket Creation -> ${response.data.message}`;
          let res = response.data.result;
          this.setState({ mediMarketId: res[0].ID });
          alert(string);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data.message) {
          alert(error.response.data.message);
          if (error.response.data.isSuccess) {
            let res = error.response.data.result;
            this.setState({ mediMarketId: res[0].ID });
          }
        }
      });
  }

  stateCodesInfo() {
    let list = [],
      listArray = {};
    const body = {
      lookUp: 'State'
    };
    _freedomAxios
      .post('corporate/lookup', body)
      .then((response) => {
        if (response.data.isSuccess) {
          list = JSON.parse(response.data.result);
          this.setState({ stateIdList: list });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert(error.response.data.message);
      });
  }

  entityIdInfo(payLoad = {}) {
    _freedomAxios
      .post('corporate/getEntity', payLoad)
      .then((response) => {
        if (response.data.isSuccess) {
          let result = response.data.result;
          if (result.length == 0) {
            let alt = `entityId --> ${response.data.message}`;
            alert(alt);
          }
          this.setState({
            entityIdInfo: result[0],
            emailDomain: result[0].E_EmailAddress,
            corporateName: result[0].corporateName
          });
        } else {
          let alert = `entityId --> ${response.data.message}`;
          alert(alert);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert(error.response.data.message);
      });
  }

  emailOTPListing() {
    if (!this.state.emailDomain) {
      return alert('Email Id is required. Please enter Email Id');
    }
    if (!this.state.corporateName) {
      return alert('Corporate Name is required. Please enter Corporate Name');
    }
    let payLoad = {
      emailDomain: this.state.emailDomain.split('@')[1],
      entityId: this.state.entityId,
      corporateType: 'NonTPA',
      corporateName: this.state.corporateName,
      LoginNameFormat:
        this.state.loginType == 'EMPID'
          ? `employeeId@` + this.state.emailDomain.split('@')[1].split('.')[0]
          : this.state.loginType,
      isSSO: this.state.isSSO,
      SSOUrl: this.state.SSOurl.length > 0 ? this.state.SSOurl : null,
      IsSelfOnboardingEnabled: this.state.selfOnbaordingEnabled
    };
    _freedomAxios
      .post('corporate/createEmailOTPConfig', payLoad)
      .then((response) => {
        if (response.data.isSuccess) {
          let result = JSON.parse(response.data.result);
          this.setState({
            entityIdInfo: result[0],
            emailDomain: result[0].E_EmailAddress
          });
          alert("Email OTP White Listing success")
        }
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert(error.response.data.message);
      });
  }

  entityTypeList() {
    let list = [],
      listArray = {};
    const body = {
      lookUp: 'ENTITY_TYPE'
    };
    _freedomAxios
      .post('corporate/lookup', body)
      .then((response) => {
        if (response.data.isSuccess) {
          list = JSON.parse(response.data.result);
          this.setState({ entityList: list });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert(error.response.data.message);
      });
  }

  entityRelationList() {
    let list = [],
      listArray = {};
    const body = {
      lookUp: 'EntityRelation'
    };
    _freedomAxios
      .post('corporate/lookup', body)
      .then((response) => {
        if (response.data.isSuccess) {
          list = JSON.parse(response.data.result);
          this.setState({ entityRelationList: list });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert(error.response.data.message);
      });
  }

  entityRelationCreation() {
    let payLoad = {
      entityId: this.state.entityId,
      contractType: Number(this.state.RelationType),
      createdBy: this.state.createdBy,
      IWPID: this.state.IWPID
    };
    if (!this.state.entityType) {
      return alert('Entity Type is required. Please select an Entity Type');
    }
    if (!this.state.entityId) {
      return alert('EntityId is required. Please enter EntityId');
    }
    if (!this.state.RelationType) {
      return alert('Relation Type is required. Please select an Relation Type');
    }

    _freedomAxios
      .post('corporate/entityRelation', payLoad)
      .then((response) => {
        if (response.data.isSuccess) {
          const res = response.data.result[0];
          this.setState({
            stepper: this.state.stepper + 1,
            entityRelationId: res.ER_Id,
            newEntityRealtion: res.ER_Id
          });
        } else {
          let string = `entity Creation -> ${response.data.messsage}`;
          alert(string);
          this.setState({
            entityRelationId: response.data.result[0].ER_Id,
            newEntityRealtion: response.data.result[0].ER_Id
          });
        }
        this.mediMarketTableMapping({
          entityId: this.state.entityId,
          contractType: this.state.RelationType,
          entityRelationId: this.state.entityRelationId,
          entityType: this.state.entityType
        });
      })
      .catch((error) => {
        if (error.response && error.response.data)
          alert('errorrrrr', error.response.data.message);
      });
  }

  entityCreation() {
    if (!this.state.corporateName || this.state.corporateName == '') {
      return alert('Please enter the Corporate Name');
    }
    if (!this.state.entityType || this.state.entityType == '') {
      return alert('Please select an Entity Type');
    }
    if (!this.state.corporateAddress || this.state.corporateAddress == '') {
      return alert('Please enter Corporate Address');
    }
    if (!this.state.pincode || this.state.pincode == '') {
      return alert('Please enter PinCode');
    }
    if (!this.state.stateId || this.state.stateId == '') {
      return alert('Please select State');
    }
    if (!this.state.hrMobileNumber || this.state.hrMobileNumber == '') {
      return alert('Please enter Mobile Number');
    }
    if (!this.state.hrName || this.state.hrName == '') {
      return alert('Please enter Name');
    }
    if (!this.state.hrEmail || this.state.hrEmail == '') {
      return alert('Please enter HR Email');
    }
    let payLoad = {
      corporateName: this.state.corporateName,
      corporateAddress: this.state.corporateAddress,
      pincode: this.state.pincode,
      hrEmail: this.state.hrEmail,
      hrMobileNumber: this.state.hrMobileNumber,
      hrName: this.state.hrName,
      modifiedBy: this.state.modifiedBy,
      entityType: this.state.entityType,
      corporateType: this.state.corporateType,
      stateId: this.state.stateId
    };
    _freedomAxios
      .post('corporate/entityCreation', payLoad)
      .then((response) => {
        if (response.data.isSuccess) {
          const entityResult = response.data.result;
          this.setState({
            stepper: this.state.stepper + 1,
            entityId: entityResult[0].id,
            newEntityId: entityResult[0].id
          });
          sessionStorage.setItem('entityId', entityResult[0].id);
        } else {
          alert(response.data.message);
          const entityResult = response.data.result;
          this.setState({
            stepper: this.state.stepper + 1,
            entityId: entityResult[0].id
          });
          sessionStorage.setItem('entityId', entityResult[0].id);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          error.response.data.message = JSON.parse(error.response.data.message);
          if (error.response.data.message.missedValues) {
            alert(error.response.data.message.missedValues);
          } else {
            alert(error.response.data.message);
          }
        }
      });
  }

  corporateAliasMapping() {
    let payload = {
      entityId: this.state.entityId,
      emailDomain: this.state.emailDomain,
      modifiedBy: this.state.createdBy,
      emailDomainAlias: this.state.emailDomainAlias
        ? this.state.emailDomainAlias
        : null,
      loginType: this.state.loginType
    };
    _freedomAxios
      .post('corporate/createCorporateAlias', payload)
      .then((response) => {
        if (response.data.isSuccess) {
          console.log(response.data);
        }
        alert(response.data.message);
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  }

  emailOTPListingComponenet() {
    return (
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 2
        }}
      >
        <Card
          sx={{
            width: '90%',
            borderRadius: 4,
            mb: 0,
            pt: 2,
            boxShadow: '0 0 4px rgba(0,0,0,0.15)',
            margin: '5%'
          }}
        >
          <CardContent alignItems="center">
            <Typography gutterBottom variant="h2" component="div">
              Email OTP White Listing
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '70%'
              }}
            >
              <label
                style={{
                  textAlign: 'left',
                  margin: '2%'
                }}
              >
                EntityId
              </label>
              <OutlinedInput
                id="outlined-search"
                sx={{
                  boxShadow: 0,
                  bgcolor: '#f2f2f2',
                  marginBottom: '3%',
                  marginLeft: '1%'
                  // alignSelf: 'center'
                }}
                labelWidth={0}
                value={this.state.entityId}
                disabled={!_.isEmpty(this.state.entityIdInfo)}
                onChange={(ev) => {
                  this.setState({ entityId: ev.target.value });
                }}
                placeholder={`Entity Id`}
              />
              {this.state.entityIdInfo.length == 0 ? (
                <Button
                  sx={{
                    width: '50%',
                    marginLeft: '25%',
                    marginTop: '3%',
                    marginBottom: '3%',
                    boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                    backgroundColor: '#143a72',
                    color: 'white'
                  }}
                  onClick={(e) =>
                    this.entityIdInfo({ entityId: this.state.entityId })
                  }
                >
                  Submit
                </Button>
              ) : (
                <>
                  <label
                    style={{
                      textAlign: 'left',
                      margin: '2%'
                    }}
                  >
                    EmailId
                  </label>
                  <OutlinedInput
                    id="outlined-search"
                    sx={{
                      width: '50%',
                      boxShadow: 0,
                      bgcolor: '#f2f2f2',
                      marginBottom: '3%',
                      marginLeft: '1%'
                      // alignSelf: 'center'
                    }}
                    labelWidth={0}
                    value={this.state.emailDomain}
                    onChange={(ev) => {
                      this.setState({ emailDomain: ev.target.value });
                    }}
                    placeholder={`Email Id`}
                  />
                  <label
                    style={{
                      textAlign: 'left',
                      marginLeft: '2%'
                    }}
                  >
                    Corporate Name
                  </label>
                  <OutlinedInput
                    id="outlined-search"
                    sx={{
                      width: '50%',
                      boxShadow: 0,
                      bgcolor: '#f2f2f2',
                      marginBottom: '3%'
                      // alignSelf: 'center'
                    }}
                    labelWidth={0}
                    value={this.state.corporateName}
                    onChange={(e) =>
                      this.setState({ corporateName: e.target.value })
                    }
                    placeholder={`Corporate Name`}
                  />
                  {this.state.entityId && this.state.emailDomain ? (
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel>LoginType</InputLabel>
                      <Select
                        value={this.state.loginType}
                        onChange={(ev) => {
                          this.setState({ loginType: ev.target.value });
                        }}
                        renderValue={(selected) => selected}
                        label="LoginType"
                        sx={{ margin: '1%' }}
                      >
                        {this.state.LoginTypeList.map((val, idx) => (
                          <MenuItem sx={{ py: 0 }} value={val.value} key={idx}>
                            <ListItemText primary={val.id} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <></>
                  )}

                  <FormControl
                    size="small"
                    fullWidth
                    variant="outlined"
                    sx={{ margin: '1%' }}
                  >
                    <InputLabel>SSO</InputLabel>
                    <Select
                      value={this.state.isSSO}
                      onChange={(ev) => {
                        this.setState({ isSSO: ev.target.value });
                      }}
                      renderValue={(selected) => selected}
                      label="SSO"
                      sx={{ margin: '1%' }}
                    >
                      {[0, 1].map((val, idx) => (
                        <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                          <ListItemText primary={val} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {this.state.isSSO == 1 && (
                    <>
                      <label
                        style={{
                          textAlign: 'left',
                          margin: '1%'
                        }}
                      >
                        SSO URL{' '}
                      </label>
                      <OutlinedInput
                        id="outlined-search"
                        sx={{
                          width: '50%',
                          boxShadow: 0,
                          bgcolor: '#f2f2f2',
                          marginBottom: '3%',
                          marginLeft: '1%'
                          // alignSelf: 'center'
                        }}
                        labelWidth={0}
                        value={this.state.SSOurl}
                        onChange={(ev) => {
                          this.setState({ SSOurl: ev.target.value });
                        }}
                        placeholder={`SSO URL`}
                      />
                    </>
                  )}

                  <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel>Self OnBoarding </InputLabel>
                    <Select
                      value={this.state.selfOnbaordingEnabled}
                      onChange={(ev) => {
                        this.setState({
                          selfOnbaordingEnabled: ev.target.value
                        });
                      }}
                      renderValue={(selected) => selected}
                      label="Self OnBoarding"
                      sx={{ margin: '1%' }}
                    >
                      {[0, 1].map((val, idx) => (
                        <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                          <ListItemText primary={val} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Button
                    sx={{
                      width: '50%',
                      marginLeft: '25%',
                      marginTop: '3%',
                      marginBottom: '3%',
                      boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                      backgroundColor: '#143a72',
                      color: 'white'
                    }}
                    onClick={(e) => this.emailOTPListing()}
                  >
                    Submit
                  </Button>
                </>
              )}
            </div>
          </CardContent>
        </Card>
      </Box>
    );
  }

  NonTPASSOComponent() {}

  componentDidMount() {
    this.entityTypeList();
    this.entityRelationList();
    this.stateCodesInfo();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>AHC | AHConBoarding </title>
        </Helmet>
        {
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 2
            }}
          >
            <Card
              sx={{
                width: '90%',
                borderRadius: 4,
                mb: 0,
                pt: 2,
                boxShadow: '0 0 4px rgba(0,0,0,0.15)',
                marginLeft: '5%'
              }}
            >
              <CardContent alignItems="center">
                <Typography gutterBottom variant="h2" component="div">
                  EntityId Creation
                </Typography>
              </CardContent>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '70%'
                }}
              >
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%'
                  }}
                >
                  Corporate Name
                </label>
                <OutlinedInput
                  id="outlined-search"
                  required
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '2%',
                    marginLeft: '1%'
                    // alignSelf: 'center'
                  }}
                  labelWidth={0}
                  value={this.state.corporateName}
                  onChange={(e) =>
                    this.setState({ corporateName: e.target.value })
                  }
                  placeholder={`Corporate Name`}
                />
                <FormControl
                  sx={{ m: 1 }}
                  size="small"
                  fullWidth
                  variant="outlined"
                  required
                >
                  <InputLabel>Entity Type</InputLabel>
                  <Select
                    required
                    value={this.state.entityTypeName}
                    onChange={(ev) => {
                      this.setState({ entityType: ev.target.value.Id });
                      this.setState({ entityTypeName: ev.target.value.entity });
                    }}
                    renderValue={(selected) => selected}
                    label="Location"
                  >
                    {this.state.entityList.map((val, idx) => (
                      <MenuItem
                        sx={{ py: 0 }}
                        value={val}
                        key={idx}
                        name={val.entity}
                      >
                        <ListItemText primary={val.entity} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '2%'
                  }}
                >
                  Corporate Address
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginLeft: '1%'
                  }}
                  labelWidth={0}
                  value={this.state.corporateAddress}
                  onChange={(e) =>
                    this.setState({ corporateAddress: e.target.value })
                  }
                  placeholder={`Corporate Address`}
                />
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '2%'
                  }}
                >
                  PinCode
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginLeft: '1%'
                  }}
                  labelWidth={0}
                  value={this.state.pincode}
                  onChange={(e) => this.setState({ pincode: e.target.value })}
                  placeholder={`PinCode`}
                />
                <FormControl
                  size="small"
                  fullWidth
                  variant="outlined"
                  sx={{ m: 1, marginTop: '3%' }}
                >
                  <InputLabel>State</InputLabel>
                  <Select
                    value={this.state.stateName}
                    onChange={(ev) => {
                      this.setState({ stateId: ev.target.value.Id });
                      this.setState({ stateName: ev.target.value.entity });
                    }}
                    renderValue={(selected) => selected}
                    label="StateId"
                  >
                    {this.state.stateIdList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                        <ListItemText primary={val.entity} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '2%'
                  }}
                >
                  Mobile Number
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginLeft: '1%'
                  }}
                  labelWidth={0}
                  value={this.state.hrMobileNumber}
                  onChange={(e) =>
                    this.setState({ hrMobileNumber: e.target.value })
                  }
                  placeholder={`Mobile Number`}
                />
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '2%'
                  }}
                >
                  Name
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginLeft: '1%'
                  }}
                  labelWidth={0}
                  value={this.state.hrName}
                  onChange={(e) => this.setState({ hrName: e.target.value })}
                  placeholder={`HR Name`}
                />
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '2%'
                  }}
                >
                  HR Email
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '2%',
                    marginLeft: '1%'
                  }}
                  labelWidth={0}
                  value={this.state.hrEmail}
                  onChange={(e) => this.setState({ hrEmail: e.target.value })}
                  placeholder={`HR Email`}
                />
                <Button
                  sx={{
                    width: '50%',
                    marginLeft: '25%',
                    marginTop: '3%',
                    marginBottom: '3%',
                    boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                    backgroundColor: '#143a72',
                    color: 'white'
                  }}
                  onClick={(e) => this.entityCreation()}
                >
                  Submit
                </Button>
                {this.state.newEntityId ? (
                  <>
                    <label
                      style={{
                        textAlign: 'left',
                        marginLeft: '2%'
                      }}
                    >
                      Entity Id
                    </label>
                    <OutlinedInput
                      id="outlined-search"
                      sx={{
                        width: '50%',
                        boxShadow: 0,
                        bgcolor: '#f2f2f2',
                        marginBottom: '3%'
                        // alignSelf: 'center'
                      }}
                      labelWidth={0}
                      disabled
                      value={this.state.newEntityId}
                      placeholder={`Entity Id`}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Card>
          </Box>
        }
        {
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 2
            }}
          >
            <Card
              sx={{
                width: '90%',
                borderRadius: 4,
                mb: 0,
                pt: 2,
                boxShadow: '0 0 4px rgba(0,0,0,0.15)',
                marginLeft: '5%'
              }}
            >
              <CardContent alignItems="center">
                <Typography gutterBottom variant="h2" component="div">
                  Entity RelationId Creation
                </Typography>
              </CardContent>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '70%'
                }}
              >
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%'
                  }}
                >
                  EntityId
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '1%',
                    marginLeft: '1%'
                    // alignSelf: 'center'
                  }}
                  labelWidth={0}
                  value={this.state.entityId}
                  onChange={(ev) => {
                    this.setState({ entityId: ev.target.value });
                  }}
                  placeholder={`Entity Id`}
                />
                <FormControl
                  size="small"
                  fullWidth
                  variant="outlined"
                  sx={{ m: 1 }}
                >
                  <InputLabel>Relation Type</InputLabel>
                  <Select
                    value={this.state.RelationTypename}
                    onChange={(ev) => {
                      this.setState({ RelationType: ev.target.value.Id });
                      this.setState({
                        RelationTypename: ev.target.value.entity
                      });
                    }}
                    renderValue={(selected) => selected}
                    label="RelationType"
                  >
                    {this.state.entityRelationList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                        <ListItemText primary={val.entity} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl
                  size="small"
                  fullWidth
                  variant="outlined"
                  sx={{ m: 1 }}
                >
                  <InputLabel>Entity Type</InputLabel>
                  <Select
                    value={this.state.entityTypeName}
                    onChange={(ev) => {
                      this.setState({ entityType: ev.target.value.Id });
                      this.setState({ entityType: ev.target.value.entity });
                    }}
                    renderValue={(selected) => selected}
                    label="Entity Type"
                  >
                    {this.state.entityList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                        <ListItemText primary={val.entity} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <label
                  style={{
                    textAlign: 'left',
                    marginLeft: '2%',
                    marginTop: '1%'
                  }}
                >
                  IWPID (For-TPA)
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '3%',
                    marginLeft: '1%'
                    // alignSelf: 'center'
                  }}
                  labelWidth={0}
                  value={this.state.IWPID}
                  onChange={(ev) => {
                    this.setState({ IWPID: ev.target.value });
                  }}
                  placeholder={`IWPID (For TPA)`}
                />
                <Button
                  sx={{
                    width: '50%',
                    marginLeft: '25%',
                    marginTop: '3%',
                    marginBottom: '3%',
                    boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                    backgroundColor: '#143a72',
                    color: 'white'
                  }}
                  onClick={(e) => this.entityRelationCreation()}
                >
                  Submit
                </Button>
                {this.state.newEntityRealtion || this.state.mediMarketId ? (
                  <>
                    {console.log(
                      this.state.newEntityRealtion,
                      this.state.mediMarketId
                    )}
                    <label
                      style={{
                        textAlign: 'left',
                        margin: '2%'
                      }}
                    >
                      Entity Relation Id
                    </label>
                    <OutlinedInput
                      id="outlined-search"
                      sx={{
                        width: '50%',
                        boxShadow: 0,
                        bgcolor: '#f2f2f2',
                        marginBottom: '3%',
                        margin: '2%'
                        // alignSelf: 'center'
                      }}
                      labelWidth={0}
                      disabled
                      value={this.state.newEntityRealtion}
                      placeholder={`Entity Id`}
                    />
                    <label
                      style={{
                        textAlign: 'left',
                        margin: '2%'
                      }}
                    >
                      Rule Engine Configuration Id
                    </label>
                    <OutlinedInput
                      id="outlined-search"
                      sx={{
                        width: '50%',
                        boxShadow: 0,
                        bgcolor: '#f2f2f2',
                        marginBottom: '3%',
                        margin: '2%'
                        // alignSelf: 'center'
                      }}
                      labelWidth={0}
                      disabled
                      value={this.state.mediMarketId}
                      placeholder={`Medi Market Id`}
                    />
                    <OutlinedInput
                      id="outlined-search"
                      sx={{
                        width: '50%',
                        boxShadow: 0,
                        bgcolor: '#f2f2f2',
                        marginBottom: '3%',
                        margin: '2%'
                        // alignSelf: 'center'
                      }}
                      labelWidth={0}
                      disabled
                      value={this.state.IWPID}
                      placeholder={`IWPID`}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Card>
          </Box>
        }
        {
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 2
            }}
          >
            <Card
              sx={{
                width: '90%',
                borderRadius: 4,
                mb: 0,
                pt: 2,
                boxShadow: '0 0 4px rgba(0,0,0,0.15)',
                margin: '5%'
              }}
            >
              <CardContent alignItems="center">
                <Typography gutterBottom variant="h2" component="div">
                  Configure Login Type
                </Typography>
              </CardContent>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '70%'
                }}
              >
                <label
                  style={{
                    textAlign: 'left',
                    margin: '2%'
                  }}
                >
                  EntityId
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '2%',
                    marginLeft: '1%'
                    // alignSelf: 'center'
                  }}
                  labelWidth={0}
                  value={this.state.entityId}
                  onChange={(ev) => {
                    this.setState({ entityId: ev.target.value });
                  }}
                  placeholder={`Entity Id`}
                />
                <label
                  style={{
                    textAlign: 'left',
                    margin: '2%'
                  }}
                >
                  EmailId
                </label>
                <OutlinedInput
                  id="outlined-search"
                  sx={{
                    boxShadow: 0,
                    bgcolor: '#f2f2f2',
                    marginBottom: '3%',
                    marginLeft: '1%'
                    // alignSelf: 'center'
                  }}
                  labelWidth={0}
                  value={this.state.emailDomain}
                  onChange={(ev) => {
                    this.setState({ emailDomain: ev.target.value });
                  }}
                  placeholder={`Email Id`}
                />

                <FormControl size="small" fullWidth variant="outlined">
                  <InputLabel>LoginType</InputLabel>
                  <Select
                    value={this.state.loginType}
                    onChange={(ev) => {
                      this.setState({ loginType: ev.target.value });
                    }}
                    renderValue={(selected) => selected}
                    label="LoginType"
                    sx={{ marginLeft: '1%' }}
                  >
                    {this.state.LoginTypeList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} value={val.value} key={idx}>
                        <ListItemText primary={val.id} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.loginType == 'EMAIL' && (
                  <>
                    <OutlinedInput
                      sx={{
                        width: '50%',
                        boxShadow: 0,
                        bgcolor: '#f2f2f2',
                        margin: '3%'

                        // alignSelf: 'center'
                      }}
                      labelWidth={0}
                      value={this.state.emailDomainAlias}
                      onChange={(ev) => {
                        this.setState({ emailDomainAlias: ev.target.value });
                      }}
                      placeholder="Email Domain Alias"
                    ></OutlinedInput>
                  </>
                )}
                <Button
                  sx={{
                    width: '50%',
                    marginLeft: '25%',
                    marginTop: '3%',
                    marginBottom: '3%',
                    boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                    backgroundColor: '#143a72',
                    color: 'white'
                  }}
                  onClick={(e) => this.corporateAliasMapping()}
                >
                  Submit
                </Button>
              </div>
            </Card>
          </Box>
        }
        <>{this.emailOTPListingComponenet()}</>
      </>
    );
  }
}
export default EntityCreation;
